import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CheckboxProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: ReactNode;
  id?: string;
  disabled?: boolean;
  className?: string;
}

export const Checkbox = ({
  checked,
  onChange,
  label,
  id,
  disabled = false,
  className,
}: CheckboxProps) => (
  <label
    htmlFor={id}
    className={cn(
      "flex items-start gap-2.5 select-none",
      disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer",
      className,
    )}
  >
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className="sr-only"
    />
    <span
      aria-hidden="true"
      className={cn(
        "relative shrink-0 w-4 h-4 mt-0.5 rounded border transition-colors duration-200",
        checked
          ? "bg-global-accent border-global-accent"
          : "bg-global-overlay border-global-primary",
      )}
    >
      {checked && (
        <svg
          className="absolute inset-0 w-full h-full text-global-title p-0.5 pointer-events-none"
          fill="none"
          viewBox="0 0 12 12"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M2 6l3 3 5-6" />
        </svg>
      )}
    </span>
    {label !== undefined && (
      <span className="text-sm text-global-primary leading-snug">{label}</span>
    )}
  </label>
);
